// Global Types
import type {
  $Children,
} from 'common.types';
import type {
  $Translate,
} from 'common.language';

// Global Components
import * as React from 'react';
import {
  Button,
  Col,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from 'reactstrap';

// Types
type $Props = $Translate & {
  children: $Children;
  id: string;
};

type $State = {
  visible: boolean;
};

class ResultPosDialogView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      visible: false,
    };
  }

  toggle(): void {
    this.setState((prevState: $State) => ({
      visible: !prevState.visible,
    }));
  }

  childrenWithToggleHandler() {
    const {
      children,
    } = this.props;

    if (React.isValidElement(children)) {
      return React.cloneElement(
        children,
        {
          // @ts-expect-error dialog
          onClick: () => this.toggle(),
        },
      );
    }

    return children;
  }

  render() {
    const {
      id,
      t,
    } = this.props;
    const {
      visible,
    } = this.state;

    return (
      <>
        {this.childrenWithToggleHandler()}
        <Modal
          centered
          id={id}
          isOpen={visible}
          size={'md'}
          toggle={() => this.toggle()}
        >
          <ModalHeader>
            <p className={'mb-0'}>
              {t('Instructions')}
            </p>
            <small>
              {t('POS field value options')}
            </small>
          </ModalHeader>
          <ModalBody className={'px-1 py-0'}>
            <Table className={'mb-0'}>
              <tbody>
                <tr>
                  <td
                    className={'py-1 px-0'}
                    style={{
                      width: '6rem',
                    }}
                  >
                    <Row className={'no-gutters'}>
                      <Col>
                        <Input
                          className={'p-0 text-center'}
                          name={'Month'}
                          placeholder={'M'}
                        />
                      </Col>
                      <Col>
                        <Input
                          className={'p-0 text-center'}
                          name={'Day'}
                          placeholder={'D'}
                        />
                      </Col>
                      <Col>
                        <Input
                          className={'p-0 text-center'}
                          name={'Hour'}
                          placeholder={'H'}
                        />
                      </Col>
                      <Col>
                        <Input
                          className={'p-0 text-center'}
                          name={'Minute'}
                          placeholder={'M'}
                        />
                      </Col>
                      <Col>
                        <Input
                          className={'p-0 text-center'}
                          name={'Second'}
                          placeholder={'S'}
                        />
                      </Col>
                    </Row>
                  </td>
                  <td className={'py-1'}>
                    {t('Finish time input (M - Month, D - Day, H - Hour, M - Minute, S - Second)')}
                  </td>
                </tr>
                <tr>
                  <td className={'py-1'}>
                    <Input
                      className={'px-1 text-center'}
                      placeholder={'POS'}
                    />
                  </td>
                  <td className={'py-1'}>
                    {t('If POS field is left undefined position is calculated defned by finish time')}
                  </td>
                </tr>
                <tr>
                  <td className={'py-1'}>
                    <Input
                      className={'px-1 text-center'}
                      placeholder={'POS'}
                      value={'1'}
                    />
                  </td>
                  <td className={'py-1'}>
                    {t('Stricly assigned position, (overwrites position calculated by defined finish time)')}
                  </td>
                </tr>
                <tr>
                  <td className={'py-1'}>
                    <Input
                      className={'px-1 text-center'}
                      placeholder={'POS'}
                      value={'DNF'}
                    />
                  </td>
                  <td className={'py-1'}>
                    {t('Circumstances defined (DNC, DNS, OCS, ZFP, UFD, BFD, SCP, DNF, RET, DSQ, DNE, DGM, RDG, DPI)')}
                  </td>
                </tr>
                <tr>
                  <td className={'py-1'}>
                    <Input
                      className={'px-1 text-center'}
                      placeholder={'POS'}
                      value={'DNF;10'}
                    />
                  </td>
                  <td className={'py-1'}>
                    {t('Circumstances defined with points assigned')}
                  </td>
                </tr>
                <tr>
                  <td className={'py-1'}>
                    <Input
                      className={'px-1 text-center'}
                      placeholder={'POS'}
                      value={'+0.5%'}
                    />
                  </td>
                  <td className={'py-1'}>
                    {t('Adds time penalty in percentage (- subtracts)')}
                  </td>
                </tr>
                <tr>
                  <td className={'py-1'}>
                    <Input
                      className={'px-1 text-center'}
                      placeholder={'POS'}
                      value={'+5s'}
                    />
                  </td>
                  <td className={'py-1'}>
                    {t('Adds time penalty in seconds (- subtracts)')}
                  </td>
                </tr>
              </tbody>
            </Table>
          </ModalBody>
          <ModalFooter>
            <Button
              color={'secondary'}
              onClick={() => this.toggle()}
            >
              {t('Close')}
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default ResultPosDialogView;
